import React from 'react';
import { DismissButton } from '@cvent/carina/components/ScrollViewWithBars';
import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import { OverallRating } from '@weddingspot/ws-core-components';
import styles from '../Reviews.module.scss';

interface HeaderProps {
    venueName: string;
    totalCount: number;
    overallRating: number;
    setIsOpen: (isOpen: boolean) => void;
}
const Header: React.FC<HeaderProps> = ({ setIsOpen, venueName, totalCount, overallRating }) => (
    <div className={styles.viewAll__header}>
        <Row>
            <Col width='fill' flex={{ alignItems: 'center', display: 'flex' }}>
                <h2> {venueName} Reviews </h2>
            </Col>
            <Col width='content'>
                <DismissButton onClick={() => setIsOpen(false)} />
            </Col>
        </Row>
        <div className={styles.viewAll__overallRating}>
            <OverallRating totalCount={totalCount} overallRating={overallRating} />
        </div>
    </div>
);

export default Header;
